import { type UserDto, type UserModel } from '../../data-layer/user/types';
import { fromBusinessDto } from '../business/toBusinessModel';

export enum BusinessRegistrationStatus {
    REGISTERED = 'registered',
    MODERATION = 'moderation',
    VERIFICATION = 'verification',
    DECLINED_FOR_BETA = 'declined_for_beta',
    DECLINED = 'declined',
    NOT_REGISTERED = 'not_registered',
    MULTIPLE_ROLE_RESTRICTED = 'multiple_role_restricted',
}

export const fromUserDto = (userDto: UserDto): UserModel => ({
    id: userDto.id,
    subscriptions: userDto.subscriptions,
    avatarUrl: userDto.yandex_avatar_url,
    displayName: userDto.yandex_public_name,
    login: userDto.yandex_login,
    profile: 'profile' in userDto ? fromBusinessDto(userDto) : undefined,
    role: userDto.role,
    businessRegistrationStatus: userDto.business_registration_status,
    bloggerRegistrationStatus: userDto.blogger_registration_status,
    bloggerRegistrationEnabled: userDto.blogger_registration_enabled,
    yandexEmail: userDto.yandex_email,
    promoteShowInFeedCollections: userDto.promote_show_in_feed_collections,
    registrationTgCode: userDto.tg_verification_id,
    cpaStatus: userDto.cpa_status,
});
